// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const error = params.get("error");

    if (error || !code) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const redirectUri = window.location.origin + "/auth/google";
        const res = await api.post("/auth/google", { code, redirect_uri: redirectUri });
        // Clean up ?code=... from the URL, then land on /game
        window.history.replaceState({}, document.title, "/game");
        navigate("/game", { replace: true, state: { user: res.data.user } });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505]">
      <div className="text-[#00F0FF] font-mono-arcade text-sm uppercase tracking-[0.3em] animate-pulse">
        Connecting to arcade...
      </div>
    </div>
  );
}
